import { Controller } from "stimulus"
import { Ajax } from "ajax"

import videojs from "video.js"
// import hls from "videojs-hlsjs-plugin"

// if (!document.createElement('video').canPlayType('application/vnd.apple.mpegURL')) {
  // hls.register(videojs);
// }

// debugger

import "./videojs-mobile-ui"
import "videojs-hotkeys"
import "./videojs-language"
import "./videojs-markers"

export default class extends Controller {

  static targets = [ "player", "video" ]
  static values = { subtitlesMode: String, subtitlesUrl: String, subtitlesCachedMode: String }
  static pingStarted = false
  static played = false
  static pingInterval = null

  // start_ping = ->
  //   if !window.ping_started
      
  //     if window.played
  //       ping_type = 'replay'
  //       id = $('#video-id').data('id')
  //     else
  //       ping_type = 'play'
  //       id = $('#video-id').data('id')

  //     window.played = true
      
  //     $.get "/ping/#{ping_type}?v=#{id}", {}, (result, status_text, jqXHR) ->
  //       if /ausgeloggt/.test(result)
  //         window.location.replace("/");

  //     window.ping_started = true
  //     window.ping_interval = setInterval ->
  //       $.get '/ping/video', {}, (result, status_text, jqXHR) ->
  //         if /ausgeloggt/.test(result)
  //           window.location.replace("/");
  //     , 10000

  // stop_ping = ->
  //   window.ping_started = false
  //   clearInterval window.ping_interval

  subtitlesToggle() {
    if (this.subtitlesModeValue == 'on') {
      this.subtitlesModeValue = 'off'
    } else {
      this.subtitlesModeValue = 'on'
    }
  }

  firstTextTrack(player) {
    for (let i = 0; i < player.textTracks().length; i++) {
      if (player.textTracks()[i].kind == "subtitles") {
        return player.textTracks()[i]
      }
    }

    return null
  }

  setSubtitlesMode() {
    this.playerTargets.forEach((el) => {

      if (this.subtitlesModeValue == 'on') {
        el.classList.add('subtitles-on')

        this.videoTargets.forEach((video) => {

          if (video.tagName == 'VIDEO') {
            
            if (videojs.getPlayer(video) && this.firstTextTrack(videojs.getPlayer(video))) {
              this.firstTextTrack(videojs.getPlayer(video)).mode = 'showing'
            }

          }

        });

      } else {
        el.classList.remove('subtitles-on')

        this.videoTargets.forEach((video) => {

          if (video.tagName == 'VIDEO') {
            
            if (videojs.getPlayer(video) && this.firstTextTrack(videojs.getPlayer(video))) {
              this.firstTextTrack(videojs.getPlayer(video)).mode = 'disabled'
            }

          }

        })

      }
    })

  }

  subtitlesModeValueChanged() {
    this.setSubtitlesMode()
  
    if (this.subtitlesModeValue != this.subtitlesCachedModeValue) {
      this.subtitlesCachedModeValue = this.subtitlesModeValue
      
      if (this.subtitlesUrlValue) {

        Ajax.post(this.subtitlesUrlValue, {player_subtitles: this.subtitlesModeValue}).then(() => {
        }).catch(() => {
          console.log('player mode value change reject')
        });

      }
    }

  }

  startPing(id) {

    if (!this.pingStarted) {
      let pingType

      if (this.played) {
        pingType = 'replay'
      } else {
        pingType = 'play'
      }

      this.played = true
      Ajax.get(`/ping/${pingType}?v=${id}`).then(() => {
      }).catch(() => {
        console.log('start ping reject')
      })

      this.pingStarted = true
      this.pingInterval = setInterval(() => {
        Ajax.get(`/ping/video`).then(() => {
        }).catch(() => {
          console.log('ping reject')
        })
      }, 10000)
    }
      
  }

  stopPing(id) {
    this.pingStarted = false
    clearInterval(this.pingInterval)
  }

  initialize() {
    this.videoTargets.forEach((video) => {
      let markers, videojs_button, widescreen_button, subtitles_button;

      if (video.dataset.markers) {
        markers = JSON.parse(video.dataset.markers).map(function(seconds) {
          return {
            time: seconds
          };
        });
      } else {
        markers = [];
      }

      let options = {
        playbackRates: [0.5, 0.75, 1, 1.25, 1.5, 2],
        language: "de",
        textTrackSettings: false
      };

      videojs_button = videojs.getComponent('Button');
      widescreen_button = videojs.extend(videojs_button, {
        constructor: function() {
          videojs_button.apply(this, arguments);
          this.controlText('Widescreen');
          this.addClass('vjs-widescreen-button');
          return this.el_.dataset.action = "player-size#toggle";
        },
        handleClick: function(e) {

          if (e.type == 'tap') {
            e.target.click()
          }

        }
      });

      videojs.registerComponent('WidescreenButton', widescreen_button);

      subtitles_button = videojs.extend(videojs_button, {
        constructor: function() {
          videojs_button.apply(this, arguments);
          this.controlText('Untertitel');
          this.addClass('vjs-subtitles-custom-button');
          return this.el_.dataset.action = "click->player#subtitlesToggle";
        },
        handleClick: function(e) {

          if (e.type == 'tap') {
            e.target.click()
          }

        }
      });

      videojs.registerComponent('SubtitlesButton', subtitles_button);

      let controller = this

      videojs(video, options).ready(function() {
        var element, mobileui_options, player;
        player = this;
        let widescreen_position = 16;

        if (controller.firstTextTrack(player)) {
          player.getChild('controlBar').addChild('SubtitlesButton', {}, 6);
          widescreen_position += 1;
        }

        player.getChild('controlBar').addChild('WidescreenButton', {}, widescreen_position);
        if (video.dataset.ping) {
          player.on('play', function() {
            controller.startPing(video.dataset.id)
          });
          player.on('pause', function() {
            controller.stopPing(video.dataset.id)
          });
          player.on('ended', function() {
            controller.stopPing(video.dataset.id)
          });
        }

        element = video;
        this.hotkeys();

        mobileui_options = {
          fullscreen: {
            lockOnRotate: false
          }
        };

        player.mobileUi(mobileui_options);
        player.one('loadedmetadata', function() {
          var markers_options, p1;
          p1 = this;
          markers_options = {
            markerStyle: {
              "width": "2px",
              "background-color": "black"
            },
            markers: markers
          };

          if (p1) {
            if (p1.markers && (typeof player.markers === "function") && player.duration() !== 0) {
              p1.markers(markers_options);
            }
            
            p1.trigger('loadedmetadata');
          }
        });

        video.addEventListener('loadedmetadata', function() {
          var markers_options;
          markers_options = {
            markerStyle: {
              "width": "2px",
              "background-color": "black"
            },
            markers: markers
          };
          
          if (player) {
            if (player.markers && (typeof player.markers === "function")) {
              player.markers(markers_options);
            }
            return player.trigger('loadedmetadata');
          }
        })

      })

    })

  }

}